import { API_BASE_URL } from '../config';

export interface FeaturedPhoto {
  id: string;
  title: string;
  caption: string;
  imageTitle: string;
  photoName: string;
  photographer: string;
  photographerUrl: string;
  photoCredits: string;
  locationLink: string;
  geoPoint: string;
  googlePlace: string;
  colorPalette: string;
  dateTime: string;
  originalImageUrl: string;
  searchText: string;
  source: string;
  safetyTags: string;
  r2UploadedDatetime: string;
  r2Urls: {
    desktop: string;
    mobile: string;
    thumbnail: string;
  };
}

class FeaturedService {
  /**
   * Fetch all featured photos via backend API
   * Returns photos sorted by dateTime (newest first)
   */
  async getFeaturedPhotos(): Promise<FeaturedPhoto[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/featured/photos`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch featured photos: ${response.status}`);
      }
      
      const data = await response.json();
      return data.photos || [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Parse photo credits to remove content in brackets
   * e.g., "Photo by Tomáš Malík (https://unsplash.com/@malcoo)" 
   * becomes "Photo by Tomáš Malík"
   */
  cleanPhotoCredits(photoCredits: string): string {
    return photoCredits.replace(/\s*\([^)]*\)/g, '');
  }
}

export const featuredService = new FeaturedService();

